import script from "./PCNewExpeditionActions.vue?vue&type=script&setup=true&lang=js"
export * from "./PCNewExpeditionActions.vue?vue&type=script&setup=true&lang=js"

import "./PCNewExpeditionActions.vue?vue&type=style&index=0&id=d39d9cfc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d39d9cfc"]])

export default __exports__